import React from "react";
import { initClarity } from "./clarity";
import { AppRoutes } from "./routes";
import { MuiThemeEA } from "./components/contexts/MuiThemeEA";
import { I18nextProvider } from "react-i18next";
import { AuthContextProvider } from "./components/contexts/AuthContext";
import { ApiContextProvider } from "./components/contexts/ApiContext";
import { AccessControlContextProvider } from "./components/contexts/AccessControlContext";
import Auth0Provider from "./components/auth/Auth0Context";
import { AuthSessionOrchestratorProvider } from "./components/auth/AuthSessionOrchestrator";
import { QueryClientProvider, QueryClient } from "react-query";
import "./scss/BootstrapTheme.scss";
import "./scss/PrimeReactTheme.scss";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import i18n from "./i18n";

const App: React.FC = () => {
  const queryClient = new QueryClient();
  initClarity();

  return (
    <Auth0Provider>
      <AuthSessionOrchestratorProvider>
        <MuiThemeEA>
          <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
              <AuthContextProvider>
                <ApiContextProvider>
                  <AccessControlContextProvider>
                    <AppRoutes />
                  </AccessControlContextProvider>
                </ApiContextProvider>
              </AuthContextProvider>
            </QueryClientProvider>
          </I18nextProvider>
        </MuiThemeEA>
      </AuthSessionOrchestratorProvider>
    </Auth0Provider>
  );
};

export default App;
